import raithuMark from './raithu-mark.png';

const LogoIcon = () => (
  <img
    src={raithuMark}
    alt="RAITHU"
    style={{ height: 28, width: 'auto', display: 'block' }}
  />
);

export default LogoIcon;
